export const VpnLogo = ({ vpn, size = 44, tile = false, className = "" }) => (
  <img
    src={`/logos/${vpn.slug}.png`}
    alt={`${vpn.name} logo`}
    width={size}
    height={size}
    loading="lazy"
    data-testid={`vpn-logo-${vpn.slug}`}
    onError={(e) => {
      e.currentTarget.style.display = "none";
    }}
    className={`shrink-0 rounded-xl object-contain ${tile ? "bg-white p-1.5 shadow-md" : ""} ${className}`}
    style={{ width: size, height: size }}
  />
);
